export default payload => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return payload;
  }

  const keys = Object.keys(payload);

  return keys.reduce((acc, key) => {
    const value = payload[key];

    if (typeof value === 'string') {
      return { ...acc, [key]: value.trim() };
    }

    return { ...acc, [key]: value };
  }, {});
};
